import Home from './containers/homeContainer';

export default Home;
